import { __esmMin as e } from "../../_virtual/_rolldown/runtime.es.js";
// libs/ui-lib/src/assets/icons/plusPrimaryIcon.svg?raw
var t, n = e((() => {
	t = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<ellipse cx=\"10.1498\" cy=\"10.0004\" rx=\"9.35\" ry=\"9.37931\" fill=\"#4D39E9\"/>\n<path d=\"M10.224 5.98047V14.7053\" stroke=\"white\" stroke-width=\"1.5926\" stroke-linecap=\"round\"/>\n<path d=\"M6.15784 10.4839H14.335\" stroke=\"white\" stroke-width=\"1.5926\" stroke-linecap=\"round\"/>\n</svg>\n";
}));
n();
export { t as default, n as init_plusPrimaryIcon };
